import classesCss from './Dropdown.module.css'
import {useRef, useState} from 'react';

const Dropdown = ({sub, link, items, menuHeight, headerHeight, containerCss=""}) => {
    const menu = useRef(null);
    const [dot, showDot] = useState(false);

    const hideDrop = () => {
        menu.current.style.transform = "scaleY(0)";
        setTimeout(() => {
            menu.current.style.display = "none";
        }, 200);
    };

    const showDrop = () => {
        menu.current.style.display = "flex";
        setTimeout(() => {
            menu.current.style.transform = "scaleY(1)";
        }, 50);
    };

    return (
        <div className={`${classesCss.dropdown} ${containerCss}`} onMouseLeave={() => {
                hideDrop();
                showDot(false); 
            }}>
            <span className={`${dot ? classesCss.active_dot : classesCss.dot}`}/>
            <a href={link} 
               className={classesCss.dropdown__sub}
               onMouseEnter={() => {
                    showDrop()
                    showDot(true)
                }}
               style={{padding: `${headerHeight} 0px`}}>
                {sub}
            </a>
            <div className={classesCss.dropdown__menu} ref={menu} style={{
                marginTop: menuHeight
            }}>
                {
                    items.map(([text, textLink], index) =>
                        <a href={textLink} className={classesCss.dropdown__menu__item} key={index}>
                            {text}
                        </a>)
                }
            </div>
        </div>
    );
};

export default Dropdown;